var React = require('react');

function SharelinkedinInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#fff","key":0}),React.createElement("path",{"d":"M19.15,12.74a4.73,4.73,0,0,1,4.73,4.73h0V23H20.73V17.47a1.58,1.58,0,0,0-3.16,0V23H14.41V17.47a4.74,4.74,0,0,1,4.74-4.73Z","fill":"#003c61","key":1}),React.createElement("rect",{"x":"9","y":"14","width":"3","height":"9","fill":"#003c61","key":2}),React.createElement("circle",{"cx":"10.5","cy":"9.5","r":"1.5","fill":"#003c61","key":3})]);
}

SharelinkedinInline.defaultProps = {"id":"Calque_1","data-name":"Calque 1","viewBox":"0 0 32 32"};

module.exports = SharelinkedinInline;

SharelinkedinInline.default = SharelinkedinInline;
